import { z } from "zod";
import { initTelemetry, attachUserInfoToTelemetry } from "./app/initTelemetry";
import { initKeycloak } from "./app/initKeycloak";
import { initClientSettings } from "./app/initClientSettings";
import { initApollo } from "./app/initApollo";
import { initAppConfig } from "./general/appConfig";
import { APP_VERSION } from "./constants";
import { getTokenUserInfo } from "./entities/keycloak";

// Explicitly load Zod v4 English locale.
// Without this, Vite's production bundle omits the locale file and all
// validation errors fall back to the generic "Invalid input" message,
// making it impossible to show users meaningful form/field error text.
z.config(z.locales.en());

const isBot = /bot|googlebot|crawler|spider|robot|crawling/i.test(
  navigator.userAgent,
);

async function bootstrap() {
  if (isBot) {
    throw new Error("Bots are not allowed");
  }
  console.info("Version: " + APP_VERSION);

  await initTelemetry();
  await initKeycloak();

  attachUserInfoToTelemetry(getTokenUserInfo());

  await initApollo();
  const [clientSettings] = await initAppConfig();
  initClientSettings(clientSettings?.data);

  const { initApp } = await import("./app/initApp");
  void initApp();
}
void bootstrap();
